import React, { useEffect, useRef } from "react";
import BackArrow from "./BackArrow";

const PrivacyPolicy = () => {
  const topRef = useRef(null);

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);
  return (
    <div className="SB-help" ref={topRef}>
      <div className="SB-pageHeader">
        <div className="SB-pageBackButton">
          <BackArrow />
        </div>
        <div className="SB-pageHeader-title">Privacy Policy</div>
      </div>
      <div className="SB-help-content">
        <h3>Our Privacy Promise</h3>
        <p>
          We never lose sight of the fact that your personal information is your
          personal information. Your privacy is important both to you and to us
          and we make the following promise to you: We are committed to
          protecting your privacy. We believe in using your personal information
          to make things simpler and better for you. We will always keep your
          personal information safe. We'll be clear and open with you about why
          we collect your personal information and how we use it. Where you have
          choices or rights, we'll explain them to you and respect your wishes.
        </p>

        <h3>Our Data Protection Officer</h3>
        <p>
          If you have any concerns about how we handle your personal
          information, you can contact our Data Protection Officer at:
          support@digibinge.com
        </p>

        <h3>Collecting information about you</h3>
        <p>
          <h4>Information we get from you.</h4>
          We collect personal information about you whenever you use our
          services. Some of it is information you give us directly when, for
          example, you register for an account or play one of our games
          <h4>Information we get from your device.</h4>
          We collect information from the devices you use to receive our
          content, products and services. This includes but is not limited to
          the following: your IP address (a number that identifies a specific
          device on the internet and is required for your device to communicate
          with websites), hardware model, operating system and version,
          software, preferred language, serial numbers, device motion
          information, mobile network information and location data. We also
          collect server logs, which include information such as dates and times
          of access, the app (website) features or pages you view, app (website)
          crashes and other system activity, and the third-party site or service
          you were using immediately before visiting our site. Every iOS device
          is assigned an Identifier for Advertisers (IDFA) which enables app
          (website) owners and advertisers to track campaigns and deliver
          personalised advertising. If you are an iOS user and have opted in to
          tracking your IDFA (Identifier for Advertisers) is used to deliver you
          personalized advertising that is relevant to you (based on information
          we have about you, including browsing history, transactional
          information, demographic information and behavioral information,
          predictive information we create about you in each case in relation to
          our services and advertising and information about what other people
          with similar interests, demographics and behaviors are looking at) and
          is used for attribution and analytics purposes to tell us when and how
          you have interacted with advertisements, including those that have
          been placed on a third party site or app, and so we can assess the
          effectiveness of our campaigns. You can opt out of this at any time by
          visiting your mobile settings (by going to
          Settings-Privacy- Advertising and turning on Limit Ad Tracking).
        </p>

        <h3>Providing our products and services</h3>
        <p>
          As you would expect, we use your personal information to provide you
          with our products and services, respond to queries, contact you about
          games played and provide you with the best possible level of customer
          service. We use technical information about your device; which
          includes, but is not limited to, operating system, browser version and
          location. As well as ensuring we can abide by our legal and regulatory
          requirements, this helps to present you with the correct version of
          our website or app, to keep it functioning securely and correctly and
          to check that users are using our services in licensed countries. Like
          most organizations, to provide our products and services we share your
          information with external organizations working on our behalf.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
